/* eslint-disable */

import axios from "axios";
import { make } from "vuex-pathify";

const url = require("../../client_config/config").url;

const state = {
  dialog: false,
  addAttendanceDialog: false,
  snackbar: { show: false, text: "", color: "green accent-4" },
  clientAttendanceItems: [],
};

const getters = {
  clientAttendance: (state) =>
    state.clientAttendanceItems.map((item) => ({
      id: item._id,
      code: item.Code,
      start: item.TimeStart,
      end: item.TimeEnd,
      signature: item.Signature,
      date: item.Date
    })),
};

const actions = {
  async getClientAttendance({ commit }, data) {
    try {
      const response = await axios.get(`${url}/attendance/client`, {
        params: data,
      });
      commit(
        "SET_SNACKBAR",
        {
          show: true,
          text: "Service Code Successfully Added",
          color: "green accent-4",
        },
        null,
        { root: true }
      );

      console.log(response.data);

      commit("SET_CLIENT_ATTENDANCE_ITEMS", response.data);

      return response.data;
    } catch (error) {
      commit("SET_SNACKBAR", {
        show: true,
        text: error.response.data.message,
        color: "red accent-4",
      });
      return error.response;
    }
  },
  async addServiceCode({ commit }, data) {
    try {
      const response = await axios.post(`${url}/serviceCodes`, data);
      commit(
        "SET_SNACKBAR",
        {
          show: true,
          text: "Service Code Successfully Added",
          color: "green accent-4",
        },
        null,
        { root: true }
      );
      return response.data;
    } catch (error) {
      commit("SET_SNACKBAR", {
        show: true,
        text: error.response.data.message,
        color: "red accent-4",
      });
      return error.response;
    }
  },

  async addCode({ commit }, data) {
    try {
      const req_body = {
        Code: data.ServiceCode,
        Unit: data.Units,
        Title: data.ServiceTitle,
      };
      const response = await axios.post(`${url}/codes`, req_body);
      commit(
        "SET_SNACKBAR",
        {
          show: true,
          text: "Service Code Successfully Added",
          color: "green accent-4",
        },
        null,
        { root: true }
      );
      return response.data;
    } catch (error) {
      commit("SET_SNACKBAR", {
        show: true,
        text: error.response.data.message,
        color: "red accent-4",
      });

      return error.response;
    }
  },
};

const mutations = {
  ...make.mutations(state),
    SET_DIALOG(state, payload) {
        state.dialog = payload.value;
        if (payload.clientId !== undefined) {
            state.clientId = payload.clientId;
        }
    },
  SET_CLIENT_ATTENDANCE_ITEMS(state, data) {
    state.clientAttendanceItems = data;
  },
  SET_ADD_ATTENDANCE_DIALOG(state, data) {
    state.addAttendanceDialog = data;
  },
    SET_CLIENT_ID(state, clientId) {
        state.clientId = clientId;
    },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
